import styled from '@emotion/styled';
import * as React from 'react';
import useMouseOverAndOut from '../../../../../hooks/useMouseOverAndOut';
import { PractitionerOrOrganization } from '../../../../../interfaces/interfaces';
import PractitionerInfo from './PractitionerInfo';
import PractitionerItem from './PractitionerItem';

interface PractitionerTableProps {
  children: React.ReactNode;
  resourceArr: Map<string, PractitionerOrOrganization>;
  practitionerOrOrg?: PractitionerOrOrganization;

  setPractitionerOrOrg(x: PractitionerOrOrganization | undefined): void;
}

const StyledContainerList = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow-y: auto;
  position: relative;
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;

const PractitionerTable = ({ children, setPractitionerOrOrg, practitionerOrOrg, resourceArr }: PractitionerTableProps) => {
  const [toggle, setToggle] = React.useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = React.useState('');

  const ValuePractitionerHandler = (id: string): void => {
    setPractitionerOrOrg(resourceArr.get(id));
    setToggle(true);
  };

  const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: string) => {
    setSelectedIndex(index);
  };

  const { mouseOverHandler, mouseOutHandler } = useMouseOverAndOut('itemId', '.MuiListItemButton-root');

  React.useEffect(() => {
    setSelectedIndex('');
  }, [resourceArr]);

  return (
    <StyledRow>
      <StyledContainerList onMouseOver={mouseOverHandler} onMouseOut={mouseOutHandler}>
        {[...resourceArr.values()].map((item) => (
          <PractitionerItem
            key={item.id}
            practitioner={item}
            getItem={ValuePractitionerHandler}
            selectedIndex={selectedIndex}
            handleListItemClick={handleListItemClick}
          />
        ))}
      </StyledContainerList>
      {children}
      {toggle && practitionerOrOrg && <PractitionerInfo value={practitionerOrOrg} setToggle={setToggle} />}
    </StyledRow>
  );
};
export default PractitionerTable;
